<template>
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 6V0H6V6H0V7H6V13H7V7H13V6H7Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'Plus',
  props: {
    theme: {
      type: String,
      validator(value) {
        return ['orange', 'grey'].indexOf(value) !== -1;
      },
      default: 'orange',
    },
  },
  computed: {
    fill() {
      if (this.theme === 'grey') {
        return '#7A838E';
      }
      return '#FF6600';
    },
  },
};
</script>
